import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "welfare_list"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  style: {
    "word-break": "break-all",
    "text-overflow": "ellipsis",
    "display": "-webkit-box",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": "3",
    "overflow": "hidden"
  }
};
const _hoisted_6 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_welfare_m = _resolveComponent("welfare_m");
  return $setup.Client === 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "body",
    style: _normalizeStyle(['zoom:' + ($setup.Client ? '20%' : '') + ';', {
      "min-width": "1560px"
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    style: {
      "cursor": "pointer",
      "object-fit": "cover",
      "width": "100%"
    },
    onClick: _cache[0] || (_cache[0] = $event => $setup.details(2, '肌功能')),
    src: "https://www.mimodental.com/assets/imgData/img/welfare/welfare_top.png"
  }), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data_list.length > 3 ? 3 : $setup.get_data_list.length, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      onClick: $event => $setup.details($setup.get_data_list[index].id, $setup.get_data_list[index].benefitName)
    }, [_createElementVNode("img", {
      src: $setup.get_data_list[index].coverUrl
    }, null, 8, _hoisted_4), _createElementVNode("h2", null, _toDisplayString($setup.get_data_list[index].benefitName), 1), _createElementVNode("span", _hoisted_5, _toDisplayString($setup.get_data_list[index].benefitExplain), 1), _cache[1] || (_cache[1] = _createElementVNode("span", {
      style: {
        "color": "#16A2B3",
        "position": "absolute",
        "bottom": "10px",
        "font-size": "15px"
      }
    }, "了解详情", -1))], 8, _hoisted_3);
  }), 256))])])], 4)) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_welfare_m)]));
}